<style>
 .th{
    font-size: 14px;
     }
</style>


<template>
   <div class="container-fluid">
      <div class="row">
         <div class="col-sm-12">
            <div class="card">
               <div class="card-header d-flex justify-content-between">
                  <div class="header-title">
                     <h4 class="card-title">News List</h4>
                  </div>
               </div>
   
               <div class="card-body">
                  <div class="row justify-content-between">
                     <div class="col-10 col-sm-10 col-md-9">
                        <div id="user_list_datatable_info" class="dataTables_filter">
                           <form class="mr-3 position-relative row">
                              <div class="form-group col-md-4">
                                 <label for="search">Search:</label>
                                 <input type="text" v-model="search" class="form-control" placeholder="Search" aria-controls="user-list-table">
                              </div>
                           </form>
                        </div>
                     </div>

                     <div class="d-flex flex-row-reverse align-items-center col-2 col-sm-2 col-md-3">
                        <b-button variant="outline-primary" class="mx-2 border-none d-flex align-items-center" v-on:click="redirectAdd" style="height: 46px!important">
                           <i class="las la-plus-square h4 m-0 p-0"></i>
                        </b-button>
                     </div>
                  </div>
                  
                  <data-tables-server :data="list" :total="dataCount">
                     <el-table-column prop="id" label="ID" sortable="custom" min-width="70" header-align="center" align="left">
                        <template scope="scope">
                           <span class="text-truncate">{{scope.row.id}}</span>
                        </template>
                     </el-table-column>
                     <el-table-column prop="name" label="Name" sortable="custom" min-width="150" header-align="center" align="left">
                        <template scope="scope">
                           <span class="text-truncate">{{scope.row.name}}</span>
                        </template>
                     </el-table-column>
                     <el-table-column prop="title" label="Title" sortable="custom" min-width="150" header-align="center" align="left">
                        <template scope="scope">
                           <span class="text-truncate">{{scope.row.title}}</span>
                        </template>
                     </el-table-column>
                     <el-table-column prop="category" label="Category" sortable="custom" min-width="150" header-align="center" align="left">
                        <template scope="scope">
                           <span class="text-truncate">{{scope.row.category}}</span>
                        </template>
                     </el-table-column>
                     <el-table-column prop="startDate" label="Start Date" sortable="custom" min-width="120" header-align="center" align="right">
                        <template scope="scope">
                           <span class="text-truncate" v-if="scope.row.start_date != null">{{moment(scope.row.start_date).format('yyyy-MM-DD')}}</span>
                           <span class="text-truncate" v-else>-</span>
                        </template>
                     </el-table-column>
                     <el-table-column prop="endDate" label="End Date" sortable="custom" min-width="120" header-align="center" align="right">
                        <template scope="scope">
                           <span class="text-truncate" v-if="scope.row.end_date != null">{{moment(scope.row.end_date).format('yyyy-MM-DD')}}</span>
                           <span class="text-truncate" v-else>-</span>
                        </template>
                     </el-table-column>
                     <el-table-column prop="createBy" label="Created By" sortable="custom" min-width="150" header-align="center" align="left">
                        <template scope="scope">
                           <span class="text-truncate" v-if="scope.row.create_by != null">{{scope.row.create_by}}</span>
                           <span class="text-truncate" v-else>-</span>
                        </template>
                     </el-table-column>
                     <el-table-column prop="createDate" label="Created Date" sortable="custom" min-width="150" header-align="center" align="right">
                        <template scope="scope">
                           <span class="text-truncate" v-if="scope.row.create_date != null">{{moment(scope.row.end_date).format('yyyy-MM-DD')}}</span>
                           <span class="text-truncate" v-else>-</span>
                        </template>
                     </el-table-column>
                     <el-table-column prop="updatedBy" label="Updated By" sortable="custom" min-width="150" header-align="center" align="left">
                        <template scope="scope">
                           <span class="text-truncate" v-if="scope.row.update_by != null">{{scope.row.update_by}}</span>
                           <span class="text-truncate" v-else>-</span>
                        </template>
                     </el-table-column>
                     <el-table-column prop="updatedDate" label="Updated Date" sortable="custom" min-width="150" header-align="center" align="right">
                        <template scope="scope">
                           <span class="text-truncate" v-if="scope.row.update_date != null">{{moment(scope.row.end_date).format('yyyy-MM-DD')}}</span>
                           <span class="text-truncate" v-else>-</span>
                        </template>
                     </el-table-column>
                     <el-table-column prop="action" label="Action" min-width="100" align="center">
                        <template scope="scope">
                           <a class="iq-bg-primary" v-b-tooltip.top title="Edit" v-bind:href="'/news/edit?id=' + scope.row.id"><i class="ri-pencil-line mr-1"></i></a>
                           <a class="iq-bg-primary" href="javascript:void()" v-b-tooltip.top title="Delete" :id=scope.row.id @click="deleteNews(scope.row.id)"><i class="ri-delete-bin-line mr-1"></i></a>
                        </template>
                     </el-table-column>
                  </data-tables-server>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { DataTablesServer } from 'vue-data-tables';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import moment from 'moment'

locale.use(lang)

const URL = require("../../../../../config");
const constants = require("../../../../constants/CommonConstants");

Vue.use(VueAxios, axios)
Vue.use(ElementUI)
Vue.use(DataTablesServer)
Vue.prototype.moment = moment

export default {
   name:'NewsList',
   data() {
      return {
         list: [],
         search: '',
         categories: [
            { value: null, text: 'All'}
         ],
         dataCount: null
      }
   },
   async mounted() {
      try {
         let response = await axios.get(URL.api.URL + '/api/news/list', { params: { m: this.$route.meta.uid } });
         this.list = response.data.news_list.rows;
         this.dataCount = response.data.news_list.count;
      } catch(error) {
         alert("Error: Retrieve user data error");
         console.log("Error: ", error);
      }
      this.categories = this.categories.concat(constants.newsCategory);
   },
   methods: {
      async deleteNews(id) {
         try {
            if(confirm("Are you sure you want to remove this record?")) {
               await axios.delete(URL.api.URL + '/api/news/delete', { params: { id: id, m: this.$route.meta.uid } });
               let response = await axios.get(URL.api.URL + '/api/news/list', { params: { m: this.$route.meta.uid } });
               this.list = response.data.news_list.rows;
               this.dataCount = response.data.news_list.count;
               location.reload();
            }
         } catch(error) {
            alert("Error: Delete record error");
            console.log("Error: ", error);
         }
      },
      async redirectAdd() {
         this.$router.push({path: '/news/add'});
      }
   },
   computed: {
      filteredNews: function() {
         return this.list.filter((item) => {
            return item.name.toLowerCase().match(this.search.toLowerCase());
         })
      }
   }
}
</script>